import { currentLocale } from '@/plugins/i18n';
import { useCommunityStore } from '@/store/communityStore';
import { Locales } from '@/store/language.interface';

function getTranslation(field: object, key: string, languageEnabled?: Locales[]): string | undefined | null {
  if (!field[key]) return null;
  const locale = currentLocale();
  const community = useCommunityStore().community;
  languageEnabled ??= community.languageEnabled;
  // Prioritize the community's default language if available
  const defaultLocale = languageEnabled.includes(community.defaultLanguage)
    ? community.defaultLanguage
    : languageEnabled[0];
  // Select the locale based on the current user's locale if available or use the default locale
  const selectedLocale = languageEnabled.includes(locale) ? locale : defaultLocale;
  // Get fallback locales excluding the selected locale
  const fallbackLocales = languageEnabled.filter((x) => x != selectedLocale && field?.[key]?.[x]);
  return field?.[key]?.[selectedLocale] || field?.[key]?.[fallbackLocales?.[0]];
}

function isOverflown(text: string, count: number): boolean {
  return text?.length > count;
}

export { getTranslation, isOverflown };
